import { Capacitor } from '@capacitor/core';
import ky from 'ky';

import { authRequiredHeadersHook } from '@/shared/api/httpClient/hooks';
import { getEnvVar } from '@/shared/utils/envVarConfig';

export const getApiUrl = () => {
  let baseUrl = getEnvVar('VITE_API_URL');

  // Android emulator uses 10.0.2.2 to reach host machine's localhost
  if (Capacitor.getPlatform() === 'android' && baseUrl.includes('localhost')) {
    baseUrl = baseUrl.replace('localhost', '10.0.2.2');
  }

  return `${baseUrl}${getEnvVar('VITE_API_URL_SUFFIX')}`;
};

export const PrivateApi = ky.create({
  prefixUrl: getApiUrl(),
  timeout: 15_000,
  hooks: {
    beforeRequest: [authRequiredHeadersHook],
  },
});

export const PublicApi = ky.create({
  prefixUrl: getApiUrl(),
});
